import { useQuery } from "@tanstack/react-query";
import {
  LanguageItem,
  LanguageProficiency,
} from "../../models/languageSkill.model";
import { languageDictionaryService } from "../../services/dictionaries/languageDictionaryService";

export const useLanguageDictionary = () => {
  return useQuery({
    queryKey: ["languages", "dictionary"],
    queryFn: async (): Promise<LanguageItem[]> => {
      return languageDictionaryService.getLanguageDictionary();
    },
    staleTime: 1000 * 60 * 15, // 15 minutes - language data doesn't change often
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};

export const useLanguageProficiencies = () => {
  return useQuery({
    queryKey: ["languages", "proficiencies"],
    queryFn: async (): Promise<LanguageProficiency[]> => {
      return languageDictionaryService.getLanguageProficiencies();
    },
    staleTime: 1000 * 60 * 15, // 15 minutes - proficiency levels are static
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};
